var _ref;
import { css } from 'styled-components';
import * as themeColors from './theme-colors';
import * as spacing from './spacing';
// Legacy Ozone design system typography tokens (theme.typography.*)
const typography = {
    productive_heading_01: css`
    font-size: 0.875rem;
    line-height: 1.125rem;
    font-weight: var(--font-weight-bold);
  `,
    body_short_01: css`
    font-size: 0.875rem;
    line-height: 1.125rem;
    font-weight: 400;
  `,
    body_short_02: css`
    font-size: 1rem;
    line-height: 1.375rem;
    font-weight: 400;
  `
};
export const theme = {
    mode: 'light',
    header: {
        layer: 9,
        height: 74
    },
    filters: {
        height: 48,
        layer: 8
    },
    table: {
        header_height: {
            small: '1.5rem',
            medium: '2rem',
            large: '2.5rem'
        },
        row_height: {
            small: '2rem',
            medium: '2.5rem',
            large: '3rem',
            x_large: '3.5rem',
            xx_large: '4rem'
        }
    },
    menu: {
        height: 40
    },
    body: {
        layer: 1
    },
    layout: {
        layout_01: '1rem'
    },
    heights: {
        small: '1.5rem',
        medium: '2rem',
        large: '2.5rem'
    },
    rem_base: 16,
    pixels: (rem)=>typeof rem === 'number' ? theme.rem_base * rem : theme.rem_base * parseFloat(rem.replace('rem', '').trim()),
    z_index: (layer)=>`var(--zindex-layer-${`0${layer}`})`,
    // Former `src/ozone` theme surface — keep shape for ThemeProvider consumers
    // (e.g. TextWrapper → theme.spacing.normal). See ADR-0004.
    colors: {
        ...themeColors || {},
        list: (_ref = themeColors === null || themeColors === void 0 ? void 0 : themeColors.colors) !== null && _ref !== void 0 ? _ref : {}
    },
    typography,
    spacing
};
export const grayTheme = {
    ...theme,
    mode: 'gray'
};
